// import { EPROTO } from "constants"
import { LoremIpsum } from "lorem-ipsum";
import {EventStruct} from "@/utils/structs"

var MockAdapter = require('axios-mock-adapter');

// This sets the mock adapter on the default instance
// var mock = new MockAdapter(axios);
var axios = require('axios');
export const mock = new MockAdapter(axios);

const lorem = new LoremIpsum({
  sentencesPerParagraph: {
    max: 8,
    min: 4
  },
  wordsPerSentence: {
    max: 16,
    min: 4
  }
});

// export const loginData = {

// }

export const memberData = [
    { 
      id: '1', 
      firstname: 'Mikisko', 
      name: 'Bub', 
      displayName: 'Mikisko Bub',
      title: 'Mr', 
      email: 'mikisko@luxushase.com', 
      phone: '+4216654545', 
      // company: 'jw', 
      role: 'ADMIN', 
      username: 'mrmikisko',
      password: 'supersecretpassword',
      description: 'Weltherrscher!',
      gravatar: 'c933997402f76f52b1d943d7c5610c38', 
      pic: ''  ,
      active: true,
      initialpwd: '',
      accountid: '1',
      // company: accountdata[0],
      // account: accountdata[0]
  }, 
  {
      id: '2', 
      firstname: "Hanna", 
      name: "Smart", 
      displayName: 'Hanna Smart',
      phone: "+421 343 4434325", 
      username: "Hanna", 
      email: "hanna@ourshop.sk", 
      role: "ADMIN", 
      auth: [], 
      active: true, 
      initialpwd: '',
      accountid: '1',
  },
  {
      id: '3', 
      firstname: "Mike", 
      name: "Cool", 
      displayName: 'Mike Cool',
      phone: "+421 423 4332213", 
      username: "Mike", 
      email: "mike@ourshop.sk", 
      role: "USER", 
      auth: [], 
      active: true, 
      initialpwd: '',
      accountid: '1',
  },  
]




export const accountData = {
    id: '1',
    aname: 'MMG Private Barbers',
    aid: 'BR9382',
    avat: 'SK43459944',
    avatreg: '37482030432432',
    aoffice: '4 Jeséniova 12416 65 \nBratislava \nTel +421 2 526 234 54, ',
    ahours: 'Mo-Sa 18:00 - 22:00',
    ashortprofile: 'Best barber shop in town',
    pic: null,
    // members: memberData,
    businesstype: 'Barber Shop',
    alerttime: 2,
    returntime: 30,
    ctags: ['fullbeard', 'stylish', 'modern', 'traditional']
}




export const userData = [
    { 
        id: '1',
        firstname: 'Mikisko', 
        name: 'Bub', 
        displayName: 'Mikisko Bub',
        title: 'Mr', 
        email: 'mikisko@luxushase.com', 
        phone: '+4216654545', 
        // company: 'jw', 
        role: 'ADMIN', 
        username: 'mrmikisko',
        password: 'supersecretpassword',
        description: 'Weltherrscher!',
        gravatar: 'c933997402f76f52b1d943d7c5610c38', 
        pic: ''  ,
        accountid: '1',
        // company: accountdata[0],
        // account: accountdata[0]
    } 


]

export const contactData = 
  [
    {id:1, group:1, firstname: 'Aanet', name:'Perkins', displayName: 'Aanet Perkins',
    channels: [
      {type: 'phone', info: '+421 908 332 543',  tags: ['volat','sms'], pref: false}, 
      {type:'email', info: 'anetperkins@gmail.com',  tags: ['mail'], pref: false}, 
      {type:'facebook', info: 'Anet Perkins',  tags: ['sprava'], pref: true}, 
      {type:'skype', info: 'O1Anet_Perkins', tags: ['volat'], pref: false},  
    ],
      status: {custtotal: 90, custvalue: '', custrel: '', custclass: 1, 
      lastcontact: '2019-07-18T13:00:00Z', tags: [] },
    },
    {id:2, group:0, firstname: 'Jozko', name:'Ipsum', displayName: 'Jozko Ipsum',
    channels: [
      {type:'phone', info: '+421 908 332 543',  tags: ['volat', 'sms'], pref: true}, 
      {type:'email', info: 'aaryjohnson@gmail.com',  tags: ['mail'], pref: false}, 
      {type:'facebook', info: 'Anet Perkins',  tags: ['sprava'], pref: true}, 
    ],
      status: {custtotal: 40, custvalue: '', custrel: '', custclass: 1, lastcontact: '', tags: []},
    },
    {id:3, group:2, firstname: 'Maria', name:'Palova', displayName: 'Maria Palova',
    channels: [
      {type:'phone', info: '+421 908 332 543',  tags: ['volat'], pref: false}, 
      {type:'facebook', info: 'Aeter Carlon',  tags: ['sprava'], pref: false}, 
      {type:'skype', info: 'O1AetCar', tags: ['volat'], pref: false}, 
    ],
      status: {custtotal: 60, custvalue: '', custrel: '', custclass: 2, lastcontact: '2019-05-18T16:00:00Z', tags: []},
    },
    {id:4, group:3, firstname: 'Arevor', name:'Hansen', displayName: 'Arevor Hansen',
    channels: [
      {type:'email', info: 'arevorhansen@gmail.com',  tags: ['mail'], pref: false}, 
      {type:'facebook', info: 'Arevor Hansen',  tags: ['sprava'], pref: true}, 
      {type:'skype', info: 'O1Arevor_Hansen',  tags: ['volat'], pref: false}, 
      {type:'twitter', info: 'AHansen',  tags: ['text'], pref: false}, 
    ],
      status: {custtotal: 10, custvalue: 1, custrel: 1, custclass: 1, lastcontact: '', tags: []},
    },
    {id:5, group:4, firstname: 'Aaron', name:'Miller', displayName: 'Aaron Miller',
    channels: [
      {type:'phone', info: '+421 908 332 543', tags: ['volat','sms'], pref: false}, 
      {type:'skype', info: 'Aaron_Miller',  tags: ['volat'], pref: false}, 
    ],
      status: {custtotal: 340, custvalue: '', custrel: '', custclass: 3, lastcontact: '', tags: []},
    },
    {id:6, group:0, firstname: 'Abbey', name:'Christensen', displayName: 'Abbey Christensen',
    channels: [
      {type:'email', info: 'abbey.christensens@gmail.com',  tags: ['mail'], pref: false}, 
      {type:'facebook', info: 'Abbey Cute',  tags: ['sprava'], pref: true}, 
    ],
      status: {custtotal: 840, custvalue: 3, custrel: 3, custclass: 4, lastcontact: '', tags: ['vip', 'stylish', 'modern']},
    },
    {id:7, group:4, firstname: 'Ali', name:'Connors', displayName: 'Ali Connors',
    channels: [
      {type:'phone', info: '+421 908 332 543',  tags: ['volat','sms'], pref: true}, 
      {type:'email', info: 'aliconnors@gmail.com',  tags: ['mail'], pref: false}, 
      {type:'facebook', info: 'Ali Connors',  tags: ['sprava'], pref: false}, 
      {type:'skype', info: 'Ali_Skype',  tags: ['volat'], pref: false}, 
    ],
      status: {custtotal: 100, custvalue: '', custrel: '', custclass: 1, lastcontact: '', tags: ['fullbeard']},
    },
    {id:8, group:0, firstname: 'Alex', name:'Nelson', displayName: 'Alex Nelson',
    channels: [
      {type:'email', info: 'alexnelson@gmail.com',  tags: ['mail'], pref: false}, 
      {type:'facebook', info: 'Alex Nelson',  tags: ['sprava'], pref: false}, 
      {type:'skype', info: 'AlexNelson',  tags: ['volat'], pref: true}, 
    ],
      status: {custtotal: 0, custvalue: '', custrel: '', custclass: 4, lastcontact: '', tags: ['modern']},
    },
    {id:9, group:1, firstname: 'Abbey', name:'Connors', displayName: 'Abbey Connors',
    channels: [
      {type:'phone', info: '+421 908 332 543',  atags: ['google'], tags: ['phone'], pref: false}, 
      {type:'email', info: 'abbeyConnors@gmail.com', atags: ['google'], tags: ['mail'], pref: false}, 
      {type:'skype', info: 'AbbeySkype',  tags: ['volat'], pref: false}, 
    ],
      status: {custtotal: 137, custvalue: '', custrel: '', custclass: null, lastcontact: '', tags: []},
    },
    {id:10, group:0, firstname: 'Wil', name:'Nelson', displayName: 'Wil Nelson',
    channels: [
      {type:'phone', info: '+421 908 332 543',  tags: ['volat','sms'], pref: false}, 
      {type:'email', info: 'Wil.Nelson@gmail.com',  tags: ['mail'], pref: false}, 
      {type:'facebook', info: 'Wil Nelson',  tags: ['sprava'], pref: true}, 
    ],
      status: {custtotal: 0, custvalue: '', custrel: '', custclass: 2, lastcontact: '', tags: []},
    },
    {id:11, group:0, firstname: 'Maria', name:'Nelson', displayName: 'Maria Nelson',
    channels: [
      {type:'phone', info: '+421 908 673 923',  tags: ['volat','sms'], pref: false}, 
      {type:'email', info: 'Maria.Nelson@gmail.com',  tags: ['mail'], pref: false}, 
      {type:'facebook', info: 'Maria Nelson',  tags: ['sprava'], pref: true}, 
    ],
      status: {custtotal: 0, custvalue: '', custrel: '', custclass: 2, lastcontact: '', tags: []},
    },
  ]


  export const purchaseData = [
    
    {id: '1', pdate: '2019-09-01T13:15:00Z', amount: 23.00, item: 'hair cut', comment: 'special hair cut', contactid: '6', userid: '1', accountid: '1'
    },
    {id: '2', pdate: '2019-09-04T16:02:00Z', amount: 15.00, item: 'beard trim', comment: '', contactid: '6', userid: '2', accountid: '1'
    },
    {id: '3', pdate: '2019-09-09T17:11:00Z', amount: 25.00, item: 'shampoo', comment: '', contactid: '6', userid: '2', accountid: '1'
    },
    {id: '4', pdate: '2019-09-10T17:11:00Z', amount: 25.00, item: 'hair cut', comment: 'special service, long hair treatment, special lotion', contactid: '4', userid: '2', accountid: '1'
    },

  ]

 
  // ===== EVENTS =====

  function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  const thisMonth = new Date().getMonth()
  const thisYear = new Date().getFullYear()
  const eventtypes = ['is-link', 'is-info', 'is-warning', 'is-success', 'is-danger']
  // const attendees = ['Tom', 'Tim', 'Jane', 'Judith']

  function createRandomEvent(id) {
    let randdate = new Date(thisYear, thisMonth, getRandomInt(30))
    
    let event = JSON.parse(JSON.stringify(EventStruct))
    event.id = id
    // event.date = randdate
    event.type = eventtypes[getRandomInt(5)]
    event.etag = lorem.generateWords(3)
    event.description = lorem.generateSentences(1)
    event.summary = lorem.generateWords(5)
    event.attendees = [] // [attendees[getRandomInt(4)] ]
    event.accoundid = '1'
    event.start.date = randdate
    event.end.date = randdate
    event.start.dateTime = randdate
    event.end.dateTime = randdate
    

    return event
  }


  export const eventData = [
    createRandomEvent('1'),
    createRandomEvent('2'),
    createRandomEvent('3'),
    createRandomEvent('4'),
    createRandomEvent('5'),
    createRandomEvent('6'),
    createRandomEvent('7'),
    createRandomEvent('8'),
    createRandomEvent('9'),
    createRandomEvent('10'),
    createRandomEvent('11'),
    createRandomEvent('12'),
  ]


  // === ACTIVITY ===


  // const messageData = [
  //   {id:'1', group:'1', name:'Aanet Perkins', message:'Ahoj ako sa mas? Dneska je pekne', date:'12.10.', status:'read'},
  //   {id:'2', group:2, name:'Jozko Ipsum', message:'Ahoj ako sa mas? Dneska je pekne', date:'12.10.', status:'read'},
  //   {id:'3', group:2, name:'Maria Palova', message:'Dobry den', date:'12.10.', status:'read'},
  //   {id:'4', group:2, name:'Aanet Perkins', message:'Ahoj ako sa mas? Dneska je pekne', date:'12.10.', status:'notread'},
  //   {id:'5', group:1, name:'Jozko Ipsum', message:'Dobry den', date:'12.10.', status:'read'},
  //   {id:'6', group:1, name:'Maria Palova', message:'Ahoj ako sa mas? Dneska je pekne', date:'12.10.', status:'read'},
  //   {id:'7', group:2, name:'Aanet Perkins', message:'Ahoj ako sa mas? Dneska je pekne', date:'12.10.', status:'notread'},
  //   {id:'8', group:1, name:'Maria Palova', message:'Dobry den', date:'12.10.', status:'read'},
  // ]


  export const activityData = [
    {id: 1, 
      due: {date: '2019-09-13T16:00:00Z', dateTime: '2019-09-13T16:00:00Z'}, 
      createdate: '2019-09-12T16:00:00Z', sent: true, channel: 'email', 
      header: '',
      message: 'Hello. Welcome to Appka!', 
      contacts: [
        {id: '1', displayName: 'Aanet Perkins'}, {id: '3', displayName: 'Maria Palova'}, {id: '5', displayName: 'Jozko Ipsum'}
      ],
      type: 'MSG_OUT', 
      groups: [], //tag OR custclass OR none 
      status: 'OPEN',
      done: false,
      eventid: ''
    },
    {id: 2, 
      // actiondate: '2019-08-13T16:00:00Z', 
      due: {date: '2019-08-13T16:00:00Z', dateTime: '2019-08-13T16:00:00Z'},
      createdate: '2019-08-12T16:00:00Z', sent: true, channel: 'email', 
      header: '',
      message: 'Hello. Welcome to Appka! Free VIP service till October 2019', 
      contacts: [
        {id: '6', displayName: 'Abbey Christense'}
      ],
      type: 'MSG_OUT',  
      groups: [], //tag OR custclass OR none 
      status: 'DONE',
      done: true,
      eventid: ''
    },
    {id: 3, 
      due: {date: '2019-09-01T16:00:00Z', dateTime: '2019-09-01T16:00:00Z'},
      // actiondate: '2019-09-01T16:00:00Z', 
      createdate: '2019-09-01T16:00:00Z', sent: true, channel: 'email', 
      header: '',
      message: 'Hello. Welcome to Appka! Get your Bonus of 10$ with your next purchase', 
      contacts: [
        {id: '9', displayName: 'Alex Nelson'}, 
        {id: '8', displayName: 'Abbey Connors'},
      ],
      type: 'MSG_OUT',  
      groups: [
        'beard'
      ], //tag OR custclass OR none 
      status: 'OPEN',
      done: false,
      eventid: ''
    },
    {id: 4, 
      due: {date: '2019-10-11T16:00:00Z', dateTime: '2019-10-11T16:00:00Z'},
      // actiondate: '2019-09-01T16:00:00Z', 
      createdate: '2019-09-01T16:00:00Z', sent: true, channel: 'email', 
      header: '',
      message: 'Hello. Welcome to Appka! Get your Bonus of 10$ with your next purchase', 
      contacts: [
        {id: '9', displayName: 'Alex Nelson'}, 
      ],
      type: 'MSG_OUT',  
      groups: [
        'color'
      ], //tag OR custclass OR none 
      status: 'OPEN',
      done: false,
      eventid: '1'
    },
  ]